import DomainCommon from './common';

const VisitAddressService = {
    enable: (visitAddressId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/visitAddress/${visitAddressId}/enable`,
                resolve, reject
            });
        });
    },
};

export default VisitAddressService;



// WEBPACK FOOTER //
// ./src/service/visitAddress.js